import 'preact/debug'
import { h } from 'preact'
import { useState } from 'preact/hooks'
import { Result } from './components/result'
import { convertAllImagesToBase64 } from './helpers/convert'
import Spinner from './components/spinner'
import html2canvas from 'html2canvas'

const App = () => {
  const [loading, setLoading] = useState(false)

  const getImage = async () => {
    setLoading(true)
    const input = document.getElementById('download')
    const canvas = await html2canvas(input, {
      proxy: '/api',
      onclone: cloned => convertAllImagesToBase64('/api', cloned),
    })
    const imageData = await canvas.toDataURL('image/jpeg')
    const dataUrl = imageData.replace(/^data:image\/[^;]+/, 'data:application/octet-stream')
    return dataUrl
  }

  const downloadFile = async (caption, dataUrl) => {
    let link = document.createElement('a')
    let filename = caption.substring(0, 10)
    link.href = dataUrl
    link.download = `${filename}.jpg`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    setLoading(false)
  }
  return (
    <div>
      <h1>Review Image Generator</h1>
      <div class='image-wrapper'>
        <Result quote='Click to edit' quoteName='Click to edit' id='download' />
        <button
          type='button'
          class='btn-download'
          onClick={async () => downloadFile('LTV Review Image', await getImage())}
          disabled={loading}>
          {loading ? <Spinner /> : '💾 Download'}
        </button>
      </div>
      <style jsx global>{`
        html,
        body {
          font: 14px/1.21 'Helvetica Neue', arial, sans-serif;
          font-weight: 400;
          color: #444;
          background-color: #f3f3f3;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        h1 {
          text-align: center;
        }
      `}</style>
      <style jsx>{`
        .image-wrapper {
          margin: 0 auto;
          padding: 2rem;
          background-color: #f3f3f3;
          text-align: center;
        }
        .btn-download {
          margin-top: 2rem;
          padding: 0.5rem;
          background: #555;
          color: #fff;
          border-radius: 0.25rem;
          font-weight: bold;
          text-transform: uppercase;
          letter-spacing: 1px;
          border: 1px solid #555;
        }

        .btn-download:hover {
          cursor: pointer;
          color: #555;
          background-color: #fff;
        }
      `}</style>
    </div>
  )
}

export default App
